import type {Component} from 'panel';

import marketingImage from 'common/assets/images/empty-state/implement-banner-thumbnail.png';

import {BannerAttrs, BannerTheme} from './types';

const TRACK_BANNER_SHOWN_EVENT_NAME = `[mp-banner] Banner Shown`;
const ICON_FROM_THEME = new Map<BannerTheme, string>([
  [BannerTheme.Base, `idea`],
  [BannerTheme.Error, `warning`],
  [BannerTheme.Info, `info`],
  [BannerTheme.Success, `circle-checkmark`],
  [BannerTheme.Warn, `warning`],
]);

const IMAGE_FROM_THEME = new Map<BannerTheme, string>([[BannerTheme.Marketing, marketingImage]]);

/**
 * Retrieves the correct icon to display for the given component.
 */
export function getIcon(banner: Component<unknown, BannerAttrs>): string {
  return banner.attr(`icon`) === `from-theme`
    ? ICON_FROM_THEME.get(banner.attr(`theme`) as BannerTheme)
    : banner.attr(`icon`);
}

/**
 * Retrieves the correct image to display for the given component.
 */
export function getImage(banner: Component<unknown, BannerAttrs>): string {
  return banner.attr(`img-src`) || IMAGE_FROM_THEME.get(banner.attr(`theme`) as BannerTheme);
}

/**
 * Retrieves the type of the component for reporting.
 */
export function getTypePropOf(banner: Component<unknown, BannerAttrs>): string {
  return banner.attr(`banner-tracking-type`) || banner.attr(`body-text`);
}

/**
 * Creates a `track` event for the given component.
 */
export function createBannerShownEventFor(banner: Component<unknown, BannerAttrs>): Event {
  return new CustomEvent(`track`, {
    bubbles: true,
    composed: true,
    cancelable: true,
    detail: {
      eventName: TRACK_BANNER_SHOWN_EVENT_NAME,
      props: {
        'Banner Type': getTypePropOf(banner),
        'Banner Message': banner.attr(`body-text`),
      },
    },
  });
}
